var map = {
	"./01_schulweg-planen.jpg": 1975,
	"./02_verhalten.jpg": 42,
	"./03_strasse-ueberqueren.jpg": 3240,
	"./04_parkende-autos.jpg": 3701,
	"./05_einsatzfahrzeuge.jpg": 844,
	"./06_ausfahrt.jpg": 7538,
	"./07_gehweginnenseite.jpg": 1219,
	"./08_radfahrer.jpg": 6379,
	"./09_kleidung.jpg": 680,
	"./10_elterntaxi.jpg": 2881,
	"./11_ohne-elterntaxi.jpg": 249,
	"./poster_collage.jpg": 2127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2177;